import React from "react";
import PropTypes from "prop-types";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import { getTranslation } from "orion-components/i18n";

const DeleteClipDialog = ({ open, onClose, onSave, isSaving, clipName }) => {
	const handleDialogClose = () => {
		if (!isSaving) {
			onClose();
		}
	};

	return (
		<Dialog
			open={open}
			onClose={handleDialogClose}
			PaperProps={{
				style: {
					backgroundColor: "#212327",
					padding: "15px",
					minWidth: "420px"
				}
			}} data-testid="orion-components-cbcomponents-new-video-player-components-main-menu-components-delete-clip-dialog-dialog"
		>
			<DialogTitle sx={{ color: "#fff" }} data-testid="orion-components-cbcomponents-new-video-player-components-main-menu-components-delete-clip-dialog-dialog-title">
				{getTranslation("global.CBComponents.newVideoPlayer.components.mainMenu.deleteClipDialog.title")}
			</DialogTitle>
			<DialogContent data-testid="orion-components-cbcomponents-new-video-player-components-main-menu-components-delete-clip-dialog-dialog-content">
				<Typography sx={{ color: "#fff", mb: 1.5 }}>
					{getTranslation(
						"global.CBComponents.newVideoPlayer.components.mainMenu.deleteClipDialog.description",
						null,
						clipName || ""
					)}
				</Typography>
			</DialogContent>
			<DialogActions data-testid="orion-components-cbcomponents-new-video-player-components-main-menu-components-delete-clip-dialog-dialog-actions">
				<Button onClick={handleDialogClose} disabled={isSaving} variant="text" style={{ color: "#B2B6BB" }} data-testid="orion-components-cbcomponents-new-video-player-components-main-menu-components-delete-clip-dialog-button">
					{getTranslation("global.CBComponents.newVideoPlayer.components.mainMenu.deleteClipDialog.cancel")}
				</Button>
				<Button onClick={onSave} disabled={isSaving} variant="contained" sx={{ color: "#fff" }} data-testid="orion-components-cbcomponents-new-video-player-components-main-menu-components-delete-clip-dialog-button-2">
					{getTranslation("global.CBComponents.newVideoPlayer.components.mainMenu.deleteClipDialog.delete")}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

DeleteClipDialog.propTypes = {
	open: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired,
	onSave: PropTypes.func.isRequired,
	isSaving: PropTypes.bool,
	clipName: PropTypes.string
};

DeleteClipDialog.defaultProps = {
	isSaving: false,
	clipName: ""
};

export default DeleteClipDialog;
